import { ExtendedAxiosError } from '../../../types/interfaces';
import { extractErrorCode } from '../../../utils/helpers/extractError';
import {
  unauthorizedStatus,
  serviceUnavailableStatus,
  notAcceptableStatus,
  unprocessableEntity,
  badRequestStatus,
  notFoundStatus
} from '../../../utils/constants/api/statuses';

const httpStatusesToIgnore = [
  unauthorizedStatus,
  serviceUnavailableStatus,
  notAcceptableStatus,
  unprocessableEntity
];

const shouldFilterHttpError = (error: ExtendedAxiosError, isGeneralErrorMessage: boolean) => {
  return (
    isMappedBadRequestError(isGeneralErrorMessage, error.response.status) ||
    isIgnoreStatusCode(error.response.status) ||
    isExpectedOktaError(error) ||
    isLogoutError(error) ||
    isNotFoundSubscriptionError(error)
  );
};

const isIgnoreStatusCode = (statusCode: number) => httpStatusesToIgnore.includes(statusCode);

const isMappedBadRequestError = (isGeneralErrorMessage: boolean, statusCode: number) => {
  return !isGeneralErrorMessage && statusCode === badRequestStatus;
};

const isNotFoundSubscriptionError = (error: ExtendedAxiosError) => {
  const errorCode = extractErrorCode(error.response.data);
  const errorCodes = ['subscription-is-deleted', 'subscription-is-missing'];

  return error.response.status === notFoundStatus && errorCodes.includes(errorCode);
};

const isExpectedOktaError = (error: ExtendedAxiosError) => {
  const errorCode = extractErrorCode(error.response.data);

  return error.response.status === notFoundStatus && errorCode === 'saml-config-not-found';
};

const isLogoutError = (error: ExtendedAxiosError) => {
  return (
    error.response.config.url === '/api/v1/login' &&
    error.response.config.method?.toLowerCase?.() === 'delete'
  );
};

export default shouldFilterHttpError;
